import { createReducer } from 'redux-create-reducer'
import { ACTION_TYPE_ADD } from './constants'

const initialState = {}

export default createReducer(initialState, {
  [ACTION_TYPE_ADD](state, { key, value }) {
    return {
      ...state,
      [key]: value,
    }
  },
})
